import { useState } from 'react';

// Superset-management UI state, lifted out of useLoggerScreen (which is at the
// 500-line cap). Owns the transient state behind the group ☰ menu + its modals
// (inbox 963ca6f2 batch 2): which group's action menu is open (with the member
// that was active when it opened), and whether the exercise picker is in "add
// to this existing group" mode. (Rename state removed AP-0n.)
export function useGroupManagement() {
  const [supersetMenu, setSupersetMenu] = useState<{
    groupId: string;
    entryIdx: number;
  } | null>(null);
  const [addToGroupId, setAddToGroupId] = useState<string | null>(null);
  return {
    supersetMenu,
    setSupersetMenu,
    addToGroupId,
    setAddToGroupId,
  };
}
